<template>
<m-pageframe
    title="Account Access Log: {organization-label}"
>
<v-container
    fluid
>

    <v-text-field
        autocomplete="off"
        label="Search"
        prepend-icon="mdi-magnify"
        v-model="full_text"
        v-on:input="update"
    >
    </v-text-field>

    <v-data-table
        v-if="results != null"
        :headers="headers"
        :items="results"
        :items-per-page="100"
        class="elevation-1"
        :hide-default-footer="true"
        disable-sort
        :footer-props="{
            disableItemsPerPage: false,
            disablePagination: false,
        }"
    >
    
        <template v-slot:item.time_date="{ item }">
            {{$rc.pretty(item.time, 'date')}}
        </template>

        <template v-slot:item.time_time="{ item }">
            {{$rc.pretty(item.time, 'time')}}
        </template>

        <template v-slot:item.from="{ item }">
            {{prettyFrom(item)}}
        </template>

        <template v-slot:item.on="{ item }">
            {{prettyOn(item)}}
        </template>

        <template v-slot:item.by="{ item }">
            {{prettyBy(item)}}
        </template>

    </v-data-table>

</v-container>
</m-pageframe>
</template>

<script>
const _ = require('lodash');
export default {
    data() {
        return {
            full_text: null,
            results: [],

            headers: [
                { text: 'Date', value: 'time_date'}, 
                { text: 'Time', value: 'time_time'}, 
                { text: 'ISP', value: 'ip_isp'},
                { text: 'From', value: 'from'}, 
                { text: 'On', value: 'on'}, 
                { text: 'By', value: 'by'},
                { text: 'Event Type', value: 'type'}, 
                { text: 'Description', value: 'text'},
            ],
        }
    },

    mounted () {
        this.doUpdate();
    },

    methods: {
        update: _.debounce(function(){
            this.doUpdate();
        }, 751),
        
        doUpdate()
        {
                this.$rc.rest({
                    'spinner': false,
                    'endpoint': 'LIST: /api/v1/account-access-log',
                
                    'params' : {
                            'organization_id': this.$route.params.organization_id,
                            'full_text': this.full_text,
                        },
                
                    'on_success': (data) => {
                            this.results = data.results;
                        },
                
                    'on_error': 'Unable to list access log entries',
                });
        },

        prettyFrom(item)
        {
            if ( item.ip_address == '127.0.0.1' )
                return 'Local Host';

            if ( item.ip_city == null &&  item.ip_region_code == null && item.ip_country_code == null )
                return 'Unknown';

            return (item.ip_city ?? '') + ', '+(item.ip_country_code ?? '')+'-'+(item.ip_region_code ?? '');
        },

       
        prettyOn(item)
        {
            let ret = [
                item.device_label == 'Other' ? null : item.device_label,
                item.device_os,
                item.device_os_version,
                item.device_browser,
                item.device_browser_version
            ];

            ret = ret.filter((el) => el != null);

            return this.$rc.pretty(ret, 'space_list');
        },

        prettyBy(item)
        {
            if ( item.auth_employee_organization_label == item.act_as_employee_organization_label )
                return item.auth_employee_label;

            if ( item.auth_employee_label == item.act_as_employee_label )
                return item.auth_employee_label;

            return item.auth_employee_label + ' @ '+ item.auth_employee_organization_label;
        },
        
    },
}
</script>

<style lang="scss" scoped>
</style>